export const SET_AUTH_EMAIL = 'SET_AUTH_EMAIL'
export const SET_IS_AUTH = 'SET_IS_AUTH'
export const SET_ACCOUNT = 'SET_ACCOUNT'
export const SET_PREVROUTE = 'SET_PREVROUTE'
export const SET_SEARCH_FORM = 'SET_SEARCH_FORM'
